/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
// GET_PROCEDURE_TYPE

export const dispatchGetProcedureResultDetails = (data) => ({
  type: actionTypes.GET_PROCEDURE_RESULT_DETAILS,
  rebateSystemSerchResult: data,
});

export const dispatchGetProcedureType = (data) => ({
  type: actionTypes.GET_PROCEDURE_TYPE,
  procedureTypeDropDown: data,
});

export const dispatchProcedureTypeDetails = (data) => ({
  type: actionTypes.GET_PROCESS_DETAILS,
  procedureDetials: data,
});

export const getProcedureResultDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROCEDURE_RESULT_DETAILS, values)
    .then((response) => {
      dispatch(dispatchGetProcedureResultDetails(response?.data));
    })
    .catch((error) => {
      dispatch(dispatchGetProcedureResultDetails(error?.response?.data));
    });
};

export const getProcedureType = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROCEDURE_TYPE)
    .then((response) => {
      dispatch(dispatchGetProcedureType(response?.data));
    })
    .catch((error) => {
      dispatch(dispatchGetProcedureType(error?.data));
    });
};
// dispatchProcedureTypeDetails

// axios.post(serviceEndPoint.GET_PROCESS_DETAILS,{
//   "processId": 951415
// }
// ).then(res=>{
// })

export const getProcedureTypeDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROCESS_DETAILS, value)
    .then((response) => {
      dispatch(dispatchProcedureTypeDetails(response?.data));
    })
    .catch((error) => {
      dispatch(dispatchProcedureTypeDetails(error?.response?.data));
    });
};
export const clearReduxProduceResultSearchScreen = () => (dispatch) => {
  dispatch(dispatchGetProcedureType([]));
};
export const clearReduxProduceResultDetailScreen = () => (dispatch) => {
  dispatch(dispatchGetProcedureResultDetails([]));
  dispatch(dispatchProcedureTypeDetails([]));
};
